import util from '../util';

const root = () => util.GetFunctionRoot();

function headers(withBody) {
  const h = { Authorization: 'Bearer ' + (localStorage.getItem('token') || '') };
  if (withBody) h['Content-Type'] = 'application/json';
  return h;
}

async function request(method, url, body) {
  const res = await fetch(`${root()}${url}`, {
    method,
    headers: headers(body !== undefined),
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  return { status: res.status, ok: res.ok, data };
}

const enc = encodeURIComponent;

export const mcpApi = {
  listKeys: () => request('GET', '/api/mcp/keys'),
  createKey: (body) => request('POST', '/api/mcp/keys', body),
  updateKey: (id, body) => request('PATCH', `/api/mcp/keys/${enc(id)}`, body),
  revokeKey: (id) => request('DELETE', `/api/mcp/keys/${enc(id)}`),
};

export default mcpApi;
